/// Chỉ nhận http(s):// và www. — không bao giờ tạo link javascript:, file:, intent:…
const LINK = /\b(?:https?:\/\/|www\.)[^\s<>"]+/gi;
/// Dấu câu dính cuối link trong câu chat ("xem www.nhk.or.jp." / "(link: https://…)").
const TRAILING = /[.,!?;:'"…。、！？」』]+$/u;

export interface TextPart {
  text: string;
  /** Có giá trị = đoạn này là link, mở bằng href này. */
  href?: string;
}

function trimLink(raw: string): string {
  let url = raw.replace(TRAILING, '');
  // ")" cuối chỉ là của link khi trong link có "(" mở tương ứng (vd link Wikipedia).
  while (url.endsWith(')') && (url.match(/\(/g)?.length ?? 0) < (url.match(/\)/g)?.length ?? 0)) {
    url = url.slice(0, -1).replace(TRAILING, '');
  }
  return url;
}

/** Tách tin nhắn thành các đoạn chữ thường và link bấm được. */
export function splitLinks(text: string): TextPart[] {
  const parts: TextPart[] = [];
  let cursor = 0;
  for (const match of text.matchAll(LINK)) {
    const url = trimLink(match[0]);
    if (!url.includes('.')) continue;
    const start = match.index ?? 0;
    if (start > cursor) parts.push({ text: text.slice(cursor, start) });
    parts.push({ text: url, href: /^https?:\/\//i.test(url) ? url : `https://${url}` });
    cursor = start + url.length;
  }
  if (cursor < text.length) parts.push({ text: text.slice(cursor) });
  return parts;
}
